import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { User, Shield, MapPin, Building2, Save } from "lucide-react";

// Sub-components
import UserRightsSetting from "./UserRightsSetting.js";
import DepartmentRightsSetting from "./DepartmentRightsSetting.js";
import LocationRightsSetting from "./LocationRightsSetting.js";

const UserRights = () => {
  const [activeTab, setActiveTab] = useState("User Rights");
  const query = new URLSearchParams(useLocation().search);
  const user_name = query.get("user_name") || "Select User";

  const tabs = [
    {
      id: "User Rights",
      label: "User Access Rights",
      icon: <Shield size={16} />,
    },
    {
      id: "Departments",
      label: "Department Access",
      icon: <Building2 size={16} />,
    },
    // { id: "Location", label: "Location Controls", icon: <MapPin size={16} /> },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "User Rights":
        return <UserRightsSetting />;
      case "Departments":
        return <DepartmentRightsSetting />;
      case "Location":
        return <LocationRightsSetting />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-slate-50 p-3">
      {/* 1. Profile Header - Focused Left Alignment */}
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-6 border-b border-slate-200 pb-6 gap-4">
        <div className="flex items-center gap-4">
          <div className="h-14 w-14 bg-blue-600 text-white rounded-xl flex items-center justify-center shadow-md shadow-blue-100">
            <User size={32} strokeWidth={1.5} />
          </div>
          <div className="space-y-0.5">
            <h1 className="text-2xl font-bold text-slate-800 tracking-tight">
              {user_name}
            </h1>
            <p className="text-sm text-slate-500 font-medium flex items-center gap-2">
              <span className="inline-block h-2 w-2 bg-emerald-500 rounded-full"></span>
              Security Management & Access Rights
            </p>
          </div>
        </div>
      </div>

      {/* 2. Main Content Card */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        {/* Modern Tab Navigation */}
        <div className="flex border-b border-slate-200 bg-white px-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-5 py-4 text-sm font-bold transition-all relative ${
                activeTab === tab.id
                  ? "text-blue-600"
                  : "text-slate-500 hover:text-slate-800"
              }`}
            >
              <span
                className={
                  activeTab === tab.id ? "text-blue-600" : "text-slate-400"
                }
              >
                {tab.icon}
              </span>
              {tab.label}
              {activeTab === tab.id && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" />
              )}
            </button>
          ))}
        </div>

        {/* 3. Rendered Content Area */}
        <div className="p-3 bg-white min-h-[500px]">
          <div className="animate-in fade-in duration-300">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRights;
